export type StatusVariant = "success" | "error" | "pending" | "resend";

interface StatusMessageProps {
  variant: StatusVariant;
  message: string;
}

// Inline status banner for success / error / pending / resend states.
export function StatusMessage({ variant, message }: StatusMessageProps) {
  return (
    <div
      className={`nl-status nl-status--${variant}`}
      role={variant === "error" ? "alert" : "status"}
      aria-live="polite"
    >
      {message}
    </div>
  );
}
